<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <LoadingComponent :loading="loadingAssociation" :message="loadingAssociationMessage" style="z-index: 1000;"></LoadingComponent>
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialogAssociatePerson" max-width="80%">
      <v-card>
        <v-card-title>
          <span>{{ $t('tags.associatePerson') }}</span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete clearable v-model="selectedPerson" :items="pessoas" :label="$t('tags.selectPerson')" item-text="nome_completo" item-value="id_pessoa"></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="dismissAssociation">{{ $t('tags.dismissAssociationButton') }}</v-btn>
          <v-btn color="primary" @click="confirmAssociation">{{ $t('tags.confirmAssociationButton') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <merus-data-table :headers="headers" :items="tags" :mostrar-inativos="mostrarInativos" :loading="loadingtable" :default-multi-sort="defaultSort"
      :loading-text="$t('tags.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="TAGS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('tags.title')" :token="token" :items="displayedItemsForExport !== null ? displayedItemsForExport : tagsFiltrados"
          :csv-title="$tc('tags.self', 2)" :csv-headers="headersCSV" :pdf-title="$tc('tags.self', 2)" :pdf-headers="headers"
          :pdf-filename="$tc('tags.self', 2)" :help-dialog-csv-fields="helpCSV" :help-dialog-csv-model="$tc('tags.self', 2)"
          :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvtags/' : null" hide-search @saveBulk="saveBulk">
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
          </template>
          <template v-slot:add v-if="canInsert">
            <v-dialog v-model="dialog" max-width="80%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row>
                        <v-col cols="12" sm="6" md="5">
                          <v-text-field v-model="editedItem.identificador_externo" :label="$t('tags.externalIdentifier')"
                            item-value="identificador_externo" clearable
                            :rules="[identificadorExternoRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="5">
                          <v-text-field v-model="editedItem.identificador_interno" :label="$t('tags.internalIdentifier')"
                            item-value="identificador_interno" clearable
                            :rules="[identificadorInternoRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-switch v-model="isAtivo" class="ma-2" :label="$t('tags.active')"></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>

      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="blue" @click="associatePerson(item)">mdi-account</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="item.associada == 1 || item.ativo == 0 || !canDelete">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import LoadingComponent from "./LoadingComponent.vue";
import EventBus from "@/utils/eventBus";

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    LoadingComponent
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    search: "",
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    isAtivo: true,
    confirmDialog: false,
    mensagemdialog: "",
    loadingtable: true,
    loadingpessoas: true,
    loadingAssociation: false,
    loadingAssociationMessage: '',
    pessoas: [],
    selectedPerson: null,
    dialogAssociatePerson: false,
    tags: [],
    displayedItemsForExport: null,
    mostrarInativos: false,
    editedIndex: -1,
    editedItem: {
      id_tag: null,
      identificador_interno: null,
      identificador_externo: null,
      ativo: null,
      ativo_extenso: null,
      id_usuario_inclusao: null,
      id_usuario_atualizacao: null,
      id_equipamento_inclusao: null,
    },
    deletedItem: {
      id_tag: null,
      identificador_interno: null,
      identificador_externo: null,
      ativo: null,
      ativo_extenso: null,
      id_usuario_inclusao: null,
      id_usuario_atualizacao: null,
      id_equipamento_inclusao: null,
    },
    defaultItem: {
      id_tag: null,
      identificador_interno: null,
      identificador_externo: null,
      ativo: null,
      ativo_extenso: null,
      id_usuario_inclusao: null,
      id_usuario_atualizacao: null,
      id_equipamento_inclusao: null,
    },
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
  }),
  computed: {
    tagsFiltrados() {
      if (!this.mostrarInativos) {
        return this.tags.filter((t) => t.ativo === true || t.ativo === 1);
      }
      return this.tags;
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t('tags.registerTag') : this.$t('tags.editTag');
    },
    messageConfirmButton() {
      return this.$t('button.confirm');
    },
    messageDismissButton() {
      return this.$t('button.dismiss');
    },
    defaultSort() {
      return [
        { value: 'ativo_extenso', options: { text: this.$t('routs.decreasing'), value: -1 } },
        { value: 'identificador_externo', options: { text: this.$t('routs.increasing'), value: 1 } }];
    },
    headersCSV() {
      return [
        { text: this.$t('csv.lineNumber'), value: "line_number", error: "error_line" },
        { text: this.$t('tags.csvHeaders.operacao'), value: "operacao" },
        { text: this.$t('tags.csvHeaders.externalIdentifier'), value: "identificador_externo", error: "error_identificador_externo" },
        { text: this.$t('tags.csvHeaders.internalIdentifier'), value: "identificador_interno", error: "error_identificador_interno" },
        { text: this.$t('tags.csvHeaders.active'), value: "ativo", error: "error_ativo" }];
    },
    helpCSV() {
      return [
        {
          label: this.$t('tags.helpCSV.externalIdentifier.label'),
          description: this.$t('tags.helpCSV.externalIdentifier.description'),
          example: this.$t('tags.helpCSV.externalIdentifier.example'),
          key: 'identificador_externo'
        },
        {
          label: this.$t('tags.helpCSV.internalIdentifier.label'),
          description: this.$t('tags.helpCSV.internalIdentifier.description'),
          example: this.$t('tags.helpCSV.internalIdentifier.example'),
          key: 'identificador_interno'
        },
        {
          label: this.$t('tags.helpCSV.active.label'),
          description: this.$t('tags.helpCSV.active.description'),
          example: this.$t('tags.helpCSV.active.example'),
          key: 'ativo'
        }
      ];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  mounted() { },
  methods: {

    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatetagrfid");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/inserttagrfid");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletetagrfid");
            this.initialize();
          },
        });
      }
    },
    initialize() {
      this.populaTags();
      this.populaPessoas();
    },
    populaTags() {
      apiController.request(apiController.endpoints.getallTagsrfid, {
        onSuccess: (response) => {
          this.tags = response.data;
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    populaPessoas() {
      this.loadingpessoas = true;
      apiController.request(apiController.endpoints.getallPessoas, {
        data: {},
        onSuccess: (response) => {
          this.pessoas = response.data;
          this.loadingpessoas = false;
        },
        onError: () => {
          this.loadingpessoas = false;
        },
      });
    },
    identificadorExternoRules() {
      if (!this.editedItem.identificador_externo) {
        return this.$t('tags.externalIdentifierRequired');
      }

      if (this.editedItem.identificador_externo != null && this.editedItem.identificador_externo.length > 0) {
        if (!validador(this.editedItem.identificador_externo, 1, 100, 0, 0)) {
          return this.$t('tags.invalidExternalIdentifier');
        } else {
          return true;
        }
      }
      return true;
    },
    identificadorInternoRules() {
      if (!this.editedItem.identificador_interno) {
        return this.$t('tags.internalIdentifierRequired');
      }

      if (this.editedItem.identificador_interno != null && this.editedItem.identificador_interno.length > 0) {
        if (!validador(this.editedItem.identificador_interno, 1, 50, 0, 0)) {
          return this.$t('tags.invalidInternalIdentifier');
        } else {
          return true;
        }
      }
      return true;
    },
    editItem(item) {
      this.editedIndex = this.tags.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.ativo == 1) {
        this.isAtivo = true;
      } else {
        this.isAtivo = false;
      }
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog =
        this.$t('tags.confirmDelete', { tag: item.identificador_externo });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteTagrfid, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.isAtivo = true;
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        if (this.isAtivo) {
          this.editedItem.ativo = 1;
        } else {
          this.editedItem.ativo = 0;
        }
        
        // Adiciona o ID do usuário logado
        if (this.user && this.user.id_usuario) {
          if (this.editedIndex == -1) {
            this.editedItem.id_usuario_inclusao = this.user.id_usuario;
          } else {
            this.editedItem.id_usuario_atualizacao = this.user.id_usuario;
          }
        }

        if (this.editedIndex == -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertTagrfid, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateTagrfid, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      if (status) {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('tags.updateTable.error.insert'), tipo: 'error' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('tags.updateTable.error.update'), tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('tags.updateTable.error.delete'), tipo: 'error' });
          }
        }
      } else {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('tags.updateTable.success.insert'), tipo: 'success' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('tags.updateTable.success.update'), tipo: 'success' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('tags.updateTable.success.delete'), tipo: 'success' });
          }
        }
        this.editedItem = this.defaultItem;
      }
      this.close();
      this.populaTags();
    },
    associatePerson(item) {
      this.editedItem = Object.assign({}, item);
      this.selectedPerson = this.editedItem.id_pessoa;
      this.dialogAssociatePerson = true;
    },
    async confirmAssociation() {
      this.operacao = 1;
      const originalPersonId = this.editedItem.id_pessoa;
      const newPersonId = this.selectedPerson;
      const tagIdentifier = this.editedItem.identificador_interno;

      // Cenário 1: Tag não está associada a nenhuma pessoa
      if (!originalPersonId && newPersonId) {
        this.loadingAssociation = true;
        this.loadingAssociationMessage = 'Associando tag...';
        try {
          const response = await apiController.request(apiController.endpoints.associaTagrfid, {
            data: {
              id_pessoa: newPersonId,
              identificador_interno: tagIdentifier
            },
            silent: true,
          });

          this.loadingAssociation = false;
          if (response.data.erro) {
            EventBus.$emit('show-alert', {
              mensagem: response.data.mensagem || this.$t('tags.updateTable.error.update'),
              tipo: 'error'
            });
          } else {
            EventBus.$emit('show-alert', {
              mensagem: response.data.mensagem || this.$t('tags.updateTable.success.update'),
              tipo: 'success'
            });
            this.dialogAssociatePerson = false;
            this.populaTags();
          }
        } catch (e) {
          this.loadingAssociation = false;
          EventBus.$emit('show-error', { error: e });
        }
      }
      // Cenário 2: Tag está associada, mas usuário limpou a seleção (desassociar)
      else if (originalPersonId && !newPersonId) {
        this.loadingAssociation = true;
        this.loadingAssociationMessage = 'Desassociando tag...';
        try {
          const response = await apiController.request(apiController.endpoints.associaTagrfid, {
            data: {
              id_pessoa: originalPersonId,
              identificador_interno: null
            },
            silent: true,
          });

          this.loadingAssociation = false;
          if (response.data.erro) {
            EventBus.$emit('show-alert', {
              mensagem: response.data.mensagem || this.$t('tags.updateTable.error.update'),
              tipo: 'error'
            });
          } else {
            EventBus.$emit('show-alert', {
              mensagem: response.data.mensagem || this.$t('tags.updateTable.success.update'),
              tipo: 'success'
            });
            this.dialogAssociatePerson = false;
            this.populaTags();
          }
        } catch (e) {
          this.loadingAssociation = false;
          EventBus.$emit('show-error', { error: e });
        }
      }
      // Cenário 3: Tag está associada a outra pessoa (desassociar antiga e associar nova)
      else if (originalPersonId && newPersonId && originalPersonId !== newPersonId) {
        this.loadingAssociation = true;
        this.loadingAssociationMessage = 'Reassociando tag...';
        try {
          // Primeiro, desassociar a pessoa antiga
          this.loadingAssociationMessage = 'Desassociando tag...';
          const disassociateResponse = await apiController.request(apiController.endpoints.associaTagrfid, {
            data: {
              id_pessoa: originalPersonId,
              identificador_interno: null
            },
            silent: true,
          });

          if (disassociateResponse.data.erro) {
            this.loadingAssociation = false;
            EventBus.$emit('show-alert', {
              mensagem: disassociateResponse.data.mensagem || this.$t('tags.updateTable.error.update'),
              tipo: 'error'
            });
            return;
          }

          // Depois, associar à nova pessoa
          this.loadingAssociationMessage = 'Associando tag à nova pessoa...';
          const associateResponse = await apiController.request(apiController.endpoints.associaTagrfid, {
            data: {
              id_pessoa: newPersonId,
              identificador_interno: tagIdentifier
            },
            silent: true,
          });

          this.loadingAssociation = false;
          if (associateResponse.data.erro) {
            EventBus.$emit('show-alert', {
              mensagem: associateResponse.data.mensagem || this.$t('tags.updateTable.error.update'),
              tipo: 'error'
            });
          } else {
            EventBus.$emit('show-alert', {
              mensagem: associateResponse.data.mensagem || this.$t('tags.updateTable.success.update'),
              tipo: 'success'
            });
            this.dialogAssociatePerson = false;
            this.populaTags();
          }
        } catch (e) {
          this.loadingAssociation = false;
          EventBus.$emit('show-error', { error: e });
        }
      }
      // Se a pessoa selecionada é a mesma que já está associada, apenas fechar o dialog
      else if (originalPersonId === newPersonId) {
        this.dismissAssociation();
      }
    },
    dismissAssociation() {
      this.loadingAssociation = false;
      this.selectedPerson = null;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialogAssociatePerson = false;
    },
    saveBulk(tags) {
      if (tags.length > 0) {
        let temp = tags.map((t) => {
          return [
            t.identificador_interno,
            t.identificador_externo,
            t.ativo !== null && t.ativo !== undefined  && t.ativo !== '' ? t.ativo : 1,
            this.user ? this.user.id_usuario : null
          ];
        });
        apiController.request(apiController.endpoints.insertTagrfidbulk, {
          data: temp,
          onSuccess: (response) => {
            this.updateTable(response.data.erro);
          },
          onError: (e) => {
            console.log("ERRO AXIOS");
            console.log(e);
          },
        });
      }
    },
  },
};
</script>

